document.addEventListener("DOMContentLoaded", function () {
	var $navToggle = document.getElementById('anewall_nav-toggle')
	var $body = document.querySelector('body')
	var $html = document.querySelector('html')

	var $mobileDropdownMenuToggle = document.querySelector('.mobile-nav__toggle-btn')
	var $mobileNavSubList = document.querySelector('.mobile-nav__sublist')

	if ($mobileDropdownMenuToggle) {
  $mobileDropdownMenuToggle.addEventListener('click', function (e) {
		if ($mobileNavSubList.style.display !== 'block') {
			$mobileNavSubList.style.display = 'block'
			$mobileDropdownMenuToggle.setAttribute("aria-expanded", true);
		} else {
			$mobileNavSubList.style.display = 'none'
			$mobileDropdownMenuToggle.setAttribute("aria-expanded", false);
		}
	})
}

	function doCloseNav() {
		$navToggle.classList.remove('js-drawer-open')
		$body.classList.remove('js-drawer-open', 'js-drawer-open-left')
		$html.classList.remove('js-drawer-open', 'js-drawer-open-left')
	}

	function doOpenNav() {
		$navToggle.classList.add('js-drawer-open')
		$body.classList.add('js-drawer-open', 'js-drawer-open-left')
		$html.classList.add('js-drawer-open', 'js-drawer-open-left')
		// $body.addEventListener('click', function (e) {
		// 	if (e.target !== $navToggle) {
		// 		console.log('not nav toggle')
		// 	}
		// 	// e.stopPropagation()
		// 	console.log(e.target)
		// 	console.log('body click')
		// 	// doCloseNav()
		// })
	}



	if ($navToggle) {
		$navToggle.addEventListener('click', function () {
			if ($navToggle.classList.contains('js-drawer-open')) {
				doCloseNav()
			} else {
				doOpenNav()
			}
		})
	}



});


